import React from "react";
import { useUscSelector } from "../../../../../redux/store";
import BasketVehicleSaleType from "../content/BasketVehicleSaleType";
import Text from "../../../../../../shared-components/toyota/styles/atoms/Text";
import Icon from "../../../../../../shared-components/toyota/styles/atoms/Icon";
import * as UscVehicleInformationStyles from "./UscVehicleInformation.styles";
import * as Styles from "./UscVehicleDealerAndSaleType.styles";

export const UscVehicleDealerAndSaleType = (): JSX.Element | null => {
    const showLocation = useUscSelector((state) => state.uscSettings.showLocation);
    const dealerCity = useUscSelector((state) => state.dealer?.dealer?.address.city);
    const vehicle = useUscSelector((state) => state.vehicle.result);
    const enableUcProgramBadges = useUscSelector((state) => state.uscSettings.enableUcProgramBadges);
    const enablePrivatelySoldVehicles = useUscSelector((state) => state.uscSettings.enablePrivatelySoldVehicles);
    const customerPromiseBannerItemsAvailable = useUscSelector(
        (state) =>
            !!state.uscSettings.ucProgramCustomerPromiseBanner?.bannerItems?.length &&
            !!state.uscSettings.nonUcProgramCustomerPromiseBanner?.bannerItems?.length,
    );
    const privatelySoldCustomerPromiseBannerItems = useUscSelector(
        (state) => state.uscSettings.privatelySoldCustomerPromiseBanner.bannerItems,
    );

    const hasVehicleSaleType =
        !vehicle ||
        !enableUcProgramBadges ||
        !customerPromiseBannerItemsAvailable ||
        (enablePrivatelySoldVehicles && !privatelySoldCustomerPromiseBannerItems?.length);

    // TODO @dylancl: optimise this check so we don't have an empty div because this will occurs to many spacing in the basket!!
    if (!dealerCity && !hasVehicleSaleType) return null;

    return (
        <Styles.Wrapper>
            {showLocation && dealerCity && (
                <UscVehicleInformationStyles.VehicleDealerCity>
                    <Icon variant="location" />
                    <Text tag="p" variant="body-small-book">
                        {dealerCity}
                    </Text>
                </UscVehicleInformationStyles.VehicleDealerCity>
            )}
            <BasketVehicleSaleType />
        </Styles.Wrapper>
    );
};

export default UscVehicleDealerAndSaleType;
